//External
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useRouter, withRouter } from "next/router";

//Internal
import Header from "../header";
import { get_cookie, headerFooterApi, metaTags } from "../../utils";
import MetaTags from "../meta-tags";
import Footer from "../footer";
import FooterSub from "../footer/footer-sub";
import ReservationHeader from "components/header/reservationHeader";

/*******************
@Purpose : Used for Private Layout
@Parameter : { children, loaders, token, userRole }
@Author : INIC
******************/
const DynamicLayout = ({
  children,
  token,
  locations,
  brandList,
  categoryList,
  addressInfo,
  cmsList,
  dynamicPageList,
  header = true,
  loader = true,
  decId = false,
  total = false,
  step,
  currentLocationId,
  fullFooter = false,
  currentPage,
  onBack,
}) => {
  const loaders = useSelector((state) => state?.ui?.loaders);
  const router = useRouter();
  const is_mobile_app = get_cookie("is_mobile_app");

  /*******************
    @purpose : for auth
    @Parameter : {}
    @Author :INIC
    ******************/
  useEffect(() => {
    if (!token) {
    }
  }, []);

  /********************
  @purpose : Get header and footer api first time render
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    if (locations.length === 0) {
      headerFooterApi();
    }
  }, []);

  /*******************
  @purpose : React hook for meta tags
  @Author : INIC
  ******************/
  useEffect(() => {
    switch (router.pathname) {
      case "/vehiclebooking":
        metaTags.title = "Vehicle Booking";
        break;
      case "/reservation":
        metaTags.title = "Reservation";
        break;
      case "/thank-you":
        metaTags.title = "Thank you";
        break;
      default:
        metaTags.title = "Exotic Car Rental - Rent An Exotic Car LAX";
        break;
    }
  }, [router.pathname]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* {loaders.content_loader && <ContentLoader />} */}
      {/****************
        @purpose : SEO Intigration
        @Author : INIC
        ******************/}
      <MetaTags metaData={metaTags} />
      {/*******************
          @purpose :Header Components
          @Author : INIC
          ******************/}
      <div className="inside-page header-sticky">
        {is_mobile_app !== "yes" && header && (
          <Header
            locations={locations}
            brandList={brandList}
            categoryList={categoryList}
            currentLocationId={currentLocationId}
          />
        )}
        {!header && <ReservationHeader step={step} onBack={onBack} />}
        {children}
        {/*******************
            @purpose :Footer Components
            @Author : INIC
            ******************/}
        {fullFooter ? (
          <Footer
            locations={locations}
            brandList={brandList}
            categoryList={categoryList}
            addressInfo={addressInfo}
            dynamicPageList={dynamicPageList}
            cmsList={cmsList}
            currentLocationId={currentLocationId}
            currentPage={currentPage}
          />
        ) : (
          <FooterSub hideSocialIcons />
        )}
      </div>
    </>
  );
};
const mapStateToProps = ({ ui, user, common }) => ({
  locations: common?.locations,
  currentLocationId: common?.currentLocationId,
  brandList: common?.brandList,
  categoryList: common?.categoryList,
  addressInfo: common?.addressInfo,
  cmsList: common?.cmsList,
  dynamicPageList: common?.dynamicPageList,
  token: user && user.token,
});

export default withRouter(connect(mapStateToProps)(DynamicLayout));
